var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.26558 0.655273H25.8187C26.6297 0.655273 27.2752 1.30079 27.2752 2.11183V25.6815C27.2752 26.476 26.6297 27.138 25.8187 27.138H19.0656V16.876H22.5083L23.0214 12.887H19.0656V10.338C19.0656 9.17941 19.3966 8.38493 21.0518 8.38493H23.1704V4.80976C22.8063 4.7601 21.5483 4.66079 20.0918 4.66079C17.0297 4.66079 14.9442 6.51458 14.9442 9.94079V12.887H11.4849V16.876H14.9442V27.138H2.26558C1.87774 27.1381 1.50554 26.9851 1.22975 26.7124C0.953961 26.4397 0.796838 26.0693 0.79248 25.6815V2.11183C0.79248 1.30079 1.45455 0.655273 2.26558 0.655273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.a983808d92b0fb128dc55360bd04f066.svg";
export { ForwardRef as ReactComponent };